const initialState = {
  requesting: false,
  requestSuccess: false,
  pending: false,
  message: null,
  loggedIn: false,
  unlinked: false,
  families: [],
  importedFamilies: [],
  errorFamilies: [],
  familiesToImport: [],
  runningJob: false,
  jobDetails: null,
  resetPasswordUrl: null,
};

export default function feed(state = initialState, action) {
  const mapFamilies = (families) =>
    families
      .map(({ members, errorMessage, ...rest }) => {
        const ContactOption = {
          EMAIL: "emails",
          PHONE: "phones",
          ADDRESS: "addresses",
        };
        const getHohContact = (hoh, option) =>
          hoh[option] &&
          hoh[option].filter((contact) => contact.is_primary).shift();

        const hoh = members.filter((member) => member.hoh).shift();
        const spouse = members
          .filter((member) => member.relationship_name === "Spouse")
          .shift();
        const email = getHohContact(hoh, ContactOption.EMAIL);
        const phone = getHohContact(hoh, ContactOption.PHONE);
        const address = getHohContact(hoh, ContactOption.ADDRESS);

        return {
          client: hoh.full_name,
          spouse: spouse ? spouse.full_name : null,
          contact: {
            email: email ? email.address : null,
            phone: phone ? phone.number : null,
          },
          address: {
            street_address: address ? address.street_address : null,
            secondary_address: address ? address.secondary_address : null,
            city: address ? address.city : null,
            state: address ? address.state : null,
            zip: address ? address.zip : null,
          },
          // id, name, imported, importStatus, importError, errorMessage
          ...rest,
        };
      })
      .sort((a, b) => a.imported - b.imported);

  switch (action.type) {
    case "REDTAIL_API_REQUESTED":
      return {
        ...state,
        requesting: true,
      };
    case "REDTAIL_LINK_ACCOUNT_SUCCESS":
      return {
        ...state,
        requesting: false,
        loggedIn: true,
        requestSuccess: action.payload.success,
        message: null,
      };
    case "REDTAIL_LINK_ACCOUNT_FAIL":
      return {
        ...state,
        requesting: false,
        loggedIn: false,
        requestSuccess: action.payload.response.data.success,
        message: action.payload.response.data.error,
      };
    case "REDTAIL_UNLINK_ACCOUNT_SUCCESS":
      return {
        ...state,
        requesting: false,
        loggedIn: false,
        unlinked: true,
        requestSuccess: action.payload.success,
        message: null,
      };
    case "REDTAIL_UNLINK_ACCOUNT_FAIL":
      return {
        ...state,
        requesting: false,
        message: action.payload.response.data.error,
      };
    case "REDTAIL_GET_FAMILIES_SUCCESS":
      return {
        ...state,
        requesting: false,
        families: mapFamilies(action.payload.families),
        requestSuccess: action.payload.success,
      };
    case "REDTAIL_GET_FAMILIES_FAIL":
      return {
        ...state,
        requesting: false,
        requestSuccess: action.payload.success,
        message: action.payload.message,
      };
    case "REDTAIL_SEARCH_FAMILIES_SUCCESS":
      return {
        ...state,
        requesting: false,
        families: mapFamilies(action.payload.families),
        requestSuccess: action.payload.success,
      };
    case "REDTAIL_SEARCH_FAMILIES_FAIL":
      return {
        ...state,
        requesting: false,
        requestSuccess: action.payload.success,
        message: action.payload.message,
      };
    case "REDTAIL_CLEAR_FAMILIES":
      return {
        ...state,
        requesting: false,
        families: [],
      };
    case "REDTAIL_QUEUE_IMPORT_JOB_REQUESTED":
      return {
        ...state,
        pending: true,
        message: "Importing Contacts"
      };
    case "REDTAIL_QUEUE_IMPORT_JOB_SUCCESS":
      return {
        ...state,
        pending: false,
        familiesToImport: action.payload.familiesToImport.map( _ => _.id),
        requestSuccess: action.payload.success,
        message: action.payload.message,
      };
    case "REDTAIL_QUEUE_IMPORT_JOB_FAIL":
      return {
        ...state,
        pending: false,
        requestSuccess: action.payload.success,
        message: action.payload.message,
      };
    case "REDTAIL_LAST_IMPORT_JOB_REQUESTED":
      return {
        ...state,
        runningJob: true,
      };
    case "REDTAIL_LAST_IMPORT_JOB_SUCCESS":
      return {
        ...state,
        runningJob: action.payload.jobDetails.status === "in-progress",
        jobDetails: mapFamilies(action.payload.jobDetails.details),
        importedFamilies: action.payload.jobDetails.details.filter( _ => _.importStatus === "imported").map( _ => _.id),
        errorFamilies: action.payload.jobDetails.details.filter( _ => _.importStatus === "failed").map( _ => _.id),
        familiesToImport: action.payload.jobDetails.details.filter( _ => _.importStatus !== "imported" && _.importStatus !== "failed").map( _ => _.id),
        requestSuccess: action.payload.success,
        message: action.payload.jobDetails.status === "completed" ? action.payload.message : state.message,
      };
    case "REDTAIL_LAST_IMPORT_JOB_FAIL":
      return {
        ...state,
        runningJob: false,
        requestSuccess: action.payload.success,
        message: action.payload.message,
      };
    case "REDTAIL_CLEAR_MESSAGE":
      return {
        ...state,
        message: null,
      };
    case "REDTAIL_CLEAR_JOB":
      return {
        ...state,
        importedFamilies: [],
        errorFamilies: [],
        familiesToImport: [],
        jobDetails: [],
        message: null,
      };
    case "REDTAIL_RESET_PASSWORD_SUCCESS":
      return {
        ...state,
        requesting: false,
        resetPasswordUrl: action.payload.resetPasswordUrl,
        message: null,
      };
    case "REDTAIL_RESET_PASSWORD_FAIL":
      return {
        ...state,
        requesting: false,
        resetPasswordUrl: null,
        requestSuccess: action.payload.response.data.success,
        message: action.payload.response.data.error,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/redtail.reducer.js